<template>
	<p>
		<button @click="$emit('onSelect')">{{ isAlive ? '👶' : '⚱️' }}</button>
		<span v-if="isSelected">{{ number }}</span>
	</p>
</template>

<script>
export default {
	props: ['number', 'isAlive', 'isSelected']
};
</script>
